<template>
  <div class="Statistics">
    <navbar title="收衣统计"></navbar>

    <!--门店类型营业额统计-->
    <div class="flex1 workload flex-column h100">
        <!--顶部选项-->
        <el-card class="box-card">
            <!--门店选择-->
            <span>请选择门店：</span>
            <div class="inblock m-left time">
                <el-select v-model="StoreSingleData.shop_id" @change="StoreSingleChange" placeholder="--请选择门店--">
                <el-option
                    v-for="(item,index) in allShop"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </div>
        </el-card>

        <!--数据展示-->
        <div class="flex1 mt10">
            <el-table
                :data="StoreSingleListData.list"
                border
                style="width: 100%"
                :height="tableHeight"
                :row-class-name="tableRowClassName">
            <el-table-column prop="name" label="门店名称" sortable></el-table-column>
             <el-table-column prop="totalCount" label="收衣件数"></el-table-column>
            <el-table-column prop="startTime" label="开始时间" sortable></el-table-column>
            <el-table-column prop="endTime" label="结束时间"></el-table-column>
            </el-table>
        </div>

        <el-card v-if="isShowPagination" class="box-card1">
          <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="StoreSingleData.page"
                :page-size.sync="StoreSingleData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="StoreSingleListData.info.count"
                background
            ></el-pagination>
          </div>
        </el-card>


    </div>
  </div>
</template>

<script>
  import header from '@/components/header'

  export default {
    components: {
      navbar: header
    },
    data() {
        return {
            // 保存所有门店数据
            allShop: [],
            isShowPagination: false,
            tableHeight: window.innerHeight - 200,
            StoreSingleListData: [],
            StoreSingleData: {
                shop_id: '',
                page: 1,
                limit: 10
            }
        }
    },
    created() {
        this.getAllShop()
        this.StoreSingleGetData()
    },
    methods: {
        // 分页大小变化
        handleSizeChange(val) {
            console.log("分页大小变化: ", val)
            this.StoreSingleData.limit = val;
            this.StoreSingleChange()
        },

        // 当前页变化
        handleCurrentChange(val) {
            console.log("当前页变化: ", val)
            this.StoreSingleData.page = val;
            this.StoreSingleChange()
        },

        // 下拉地址选择的时候
        StoreSingleChange(item) {
            this.StoreSingleGetData()
        },

        /**
         * 请求单个门店营业额 发送请求
         * @constructor
         */
        async StoreSingleGetData() {
            this.StoreSingleListData = await (await this.$http.shopClothCount(this.StoreSingleData)).data.data
            if (this.StoreSingleListData.list.length !== 0) {
                this.isShowPagination = true
            } else {
                this.isShowPagination = false
            }
        },

        // 获取所有门店数据 
        async getAllShop() {
            this.allShop = (await this.$http.allShop()).data.data;
        },
        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 == 0) {
                return 'warning-row';
            }
            return '';
        },
    }
  }
</script>

<style>

</style>